import { render, staticRenderFns } from "./ReferralCodeWidget.vue?vue&type=template&id=6d2799dc&"
import script from "./ReferralCodeWidget.vue?vue&type=script&lang=js&"
export * from "./ReferralCodeWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports